import * as angular from "angular";
import {IController} from "angular";

export class AgentTypeSelectListCtrl implements IController {

  agentStatus: any;
  ngPlaceholder: any;
  onChange: Function;

  private queryString: string;
  private statuses: any;

  /* @ngInject */
  constructor(private agentConstants) {
  }

  $onInit() {
    this.statuses = this.agentConstants.statuses;
  }

  submitQuery(query) {
    this.queryString = query;
  }

}

angular
    .module('bringoz.admin.agents')
    .component('agentStatusSelectList', {
        bindings: {
          agentStatus: '<',
          ngPlaceholder: '@?',
          onChange: '&'
        },
        template: require('./agent-status-select-list.html').default,
        controller: AgentTypeSelectListCtrl
    });
